"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = __importDefault(require("stremio/common/Button"));
var Option_less_1 = __importDefault(require("./Option.less"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Option = function (_a) {
    var _b;
    var option = _a.option, selectedOption = _a.selectedOption, onSelect = _a.onSelect;
    // consider using option.id === selectedOption?.id instead
    var selected = (0, react_1.useMemo)(function () { return (option === null || option === void 0 ? void 0 : option.value) === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value); }, [option, selectedOption]);
    var handleClick = (0, react_1.useCallback)(function () {
        onSelect(option.value);
    }, [onSelect, option.value]);
    return (react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)(Option_less_1.default['option'], (_b = {}, _b[Option_less_1.default['selected']] = selected, _b)), key: option.id, onClick: handleClick, "aria-selected": selected },
        react_1.default.createElement("div", { className: Option_less_1.default['label'] }, option.label),
        selected && !option.level ?
            react_1.default.createElement("div", { className: Option_less_1.default['icon'] })
            : null,
        option.level ?
            react_1.default.createElement(react_2.default, { name: 'caret-right', className: Option_less_1.default['option-caret'] })
            : null));
};
exports.default = Option;
